<template>
  <div class="container-fluid subpage">
    <router-link to="/">
      <div class="back back--form">Strona główna</div>
    </router-link>
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-PB84V7X"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe>
    </noscript>
    <div class="thankyou__content">
      <div class="thankyou__text">
        <h2  class="pb-1" v-html="content.data.thankyou.intro"></h2>
  <center><img src="https://rewolucyjna.pl/img/books.72e73519.png" width="200px"></center>
        <span v-html="content.data.thankyou.content"></span>
      </div>
      <div class="thankyou__sm px-5">
        <div class="footer__title py-2">Udostępnij "Rewolucyjną..."<br>i zaproś znajomych do projektu!</div>
        <ul class="footer__sm p-0">
          <li class="footer__item">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=https%3A//rewolucyjna.pl/?fundraiser=fbshare"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="53"
                height="40"
                viewBox="0 0 53 40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29.6687 9.7124C26.3413 9.7124 24.3898 11.2423 24.3898 14.7282V17.7954H20.1693V21.4694H24.3898V30.2872H28.6102V21.4694H31.9866L32.8307 17.7954H28.6102V15.3499C28.6102 14.0368 29.1023 13.3865 30.5179 13.3865H32.8307V9.86304C32.4306 9.81601 31.2649 9.7124 29.6687 9.7124Z"
                />
              </svg>
            </a>
          </li>
          <li class="footer__item">
            <a
              href="https://www.linkedin.com/shareArticle?mini=true&url=https://rewolucyjna.pl/?fundraiser=linshare"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="53"
                height="40"
                viewBox="0 0 53 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.3942 9.7124C19.0805 9.71216 18.7698 9.77583 18.4799 9.89979C18.1899 10.0237 17.9264 10.2056 17.7045 10.4348C17.4825 10.6641 17.3064 10.9364 17.1862 11.236C17.066 11.5357 17.0041 11.8569 17.0039 12.1814C17.0039 13.5468 18.0738 14.6784 19.3915 14.6784C20.711 14.6784 21.7818 13.5468 21.7818 12.1832C21.7821 11.8589 21.7205 11.5376 21.6006 11.2378C21.4807 10.9381 21.3049 10.6657 21.0831 10.4362C20.8614 10.2067 20.5981 10.0247 20.3083 9.90052C20.0185 9.77633 19.7079 9.7124 19.3942 9.7124ZM31.0536 16.2589C29.0468 16.2589 27.8991 17.3438 27.3474 18.423H27.2895V16.5498H23.3346V30.2872H27.4559V23.4872C27.4559 21.6954 27.5862 19.9633 29.7305 19.9633C31.844 19.9633 31.8748 22.0068 31.8748 23.6004V30.2872H35.9961V22.7419C35.9961 19.0496 35.2282 16.2589 31.0536 16.2589ZM17.3322 16.5488V30.2872H21.4562V16.5488H17.3322Z"
                  fill="white"
                />
              </svg>
            </a>
          </li>
          <li class="footer__item">
            <a
              href="https://twitter.com/intent/tweet?text=Chcesz%20pozna%C4%87%20przepisy%20na%20lepsz%C4%85%20Polsk%C4%99,%20a%20jednocze%C5%9Bnie%20zasmakowa%C4%87%20pysznej%20kuchni%20ro%C5%9Blinnej?%20Wesprzyj%20powstanie%20%E2%80%9CRewolucyjnej%20ksi%C4%85%C5%BCki%20kucharskiej%E2%80%A6%E2%80%9D%20i%20realizacj%C4%99%20stoj%C4%85cych%20za%20ni%C4%85%20idei!%20%0A%F0%9F%91%89%20https%3A//rewolucyjna.pl%0A%0A%23rewolucyjna%20%23lepszapolska"
              target="_blank"
              rel="noopener noreferrer"
              ><img src="@/assets/images/icons/f_twitter.svg" alt="Twitter"
            /></a>
          </li>
          <li class="footer__item">
            <a
              href="https://wa.me/?text=Chcesz%20pozna%C4%87%20przepisy%20na%20lepsz%C4%85%20Polsk%C4%99%2C%20a%20jednocze%C5%9Bnie%20zasmakowa%C4%87%20pysznej%20kuchni%20ro%C5%9Blinnej%3F%20Wesprzyj%20powstanie%20%E2%80%9CRewolucyjnej%20ksi%C4%85%C5%BCki%20kucharskiej%E2%80%A6%E2%80%9D%20i%20realizacj%C4%99%20stoj%C4%85cych%20za%20ni%C4%85%20idei!%0A%20%20%0A%F0%9F%91%89%20https%3A%2F%2Frewolucyjna.pl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="@/assets/images/icons/wa.svg"
                class="pt-1"
                alt="WhatsApp"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  title: " Potwierdzenie zamówienia",
  inject: ["content"],
  pageSlug: encodeURIComponent(window.location.href),
  text: "Stań się częścią naszej wspólnej historii i wesprzyj nas.",

  mounted() {
    let fbScript = document.createElement("script");
    fbScript.text = `
      let purchaseAmount = new URLSearchParams(location.search).get("a");
      let eventId = new URLSearchParams(location.search).get("p");
      fbq('track', 'Purchase', {
        value: purchaseAmount,
        currency: 'PLN'
      }, {eventID: eventId });
    `;
    document.body.appendChild(fbScript);

    let gtmScript = document.createElement("script");

    gtmScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-PB84V7X');`;

    document.body.appendChild(gtmScript);
  },
};
</script>
